var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.64 10.1L30.64 6.09999H30.5C30.4069 6.09063 30.3131 6.09063 30.22 6.09999H29.76H29.5H29.36L18 9.99999L6.64001 6.09999C6.33924 6.00081 6.01921 5.97448 5.70628 6.02316C5.39334 6.07184 5.09644 6.19413 4.84001 6.37999C4.58152 6.56402 4.37054 6.80691 4.22448 7.0886C4.07842 7.37029 4.00147 7.68269 4.00001 7.99999V36C3.99892 36.4193 4.12964 36.8283 4.37369 37.1692C4.61774 37.5102 4.96276 37.7658 5.36001 37.9L17.36 41.9C17.7629 42.0314 18.1971 42.0314 18.6 41.9L30 38.1L41.36 42C41.5724 42.0288 41.7876 42.0288 42 42C42.4182 42.0059 42.8264 41.8722 43.16 41.62C43.4185 41.436 43.6295 41.1931 43.7755 40.9114C43.9216 40.6297 43.9985 40.3173 44 40V12C44.0011 11.5807 43.8704 11.1717 43.6263 10.8307C43.3823 10.4898 43.0373 10.2342 42.64 10.1ZM16 37.22L8.00001 34.56V10.78L16 13.44V37.22ZM28 34.56L20 37.22V13.44L28 10.78V34.56ZM40 37.22L32 34.56V10.78L40 13.44V37.22Z",
    fill: "#FBF9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.34f44d0ccaa8e4f0cd949e1f53c24135.svg";
export { ForwardRef as ReactComponent };